import React from "react";

export default function TextInput({
  label,
  value,
  onChange,
  onBlur,
  type = "text",
  placeholder,
  error,
}) {
  return (
    <div className="form-group mb-3">
      {label && <label className="form-label fw-semibold mb-1 text-lg">{label}</label>}
      <input
        type={type}
        value={value || ""}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        className={`form-control ${error ? "is-invalid" : ""}`}
      />
      {error && <div className="invalid-feedback">{error}</div>}
    </div>
  );
}
